import { toast } from "react-toastify";
import AuthManager from "../../../Common/AuthManager";
import ServiceWrapper from "../../../Services/ServiceWrapper";
const MID_WAY_URL = process.env.REACT_APP_CONNECTION_API;

export const connectionHeaders = [
  { label: "UID", map: "uid", options: { copy: true, truncate: 5 } },
  { label: "File Name", map: "filename" },
  // { label: "Merchant Id", map: "channel_key" },
  { label: "Started By", map: "user_name", options: { sort: true } },
  { label: "Started At", map: "created_at", options: { sort: true } },
  { label: "Status", map: "status", options: { sort: true } },
  { label: "Time Taken", map: "completed_time" },
  { label: "View Logs", map: null },
];

const deleteSchedule = async (id, callback) => {
  const res = await ServiceWrapper.doDelete(
    `${MID_WAY_URL}schedule/${id}`,
    null,
    null,
    AuthManager.getGmsToken()
  );
  if (res?.data?.done) {
    toast.success("Delete successfully");
    callback && callback();
  } else {
    toast.error("Delete failed");
  }
};

const scheduleTableHeaders = [
  { label: "UID", map: "uid", options: { copy: true, truncate: 5 } },
  { label: "Type", map: "type", options: { sort: true } },
  { label: "Data Type", map: "data_type", options: { sort: true } },
  { label: "Started Date", map: "startDate", options: { sort: true } },
  { label: "End Date", map: "endDate", options: { sort: true } },
  { label: "Started By", map: "user_name", options: { sort: true } },
  { label: "Created At", map: "created_at", options: { sort: true } },
  { label: "Repeat", map: "repeat", options: { sort: true } },
  {
    label: "Delete",
    options: { api: "schedule/", apiKey: "uid", callback: deleteSchedule },
  },
];

export const connectionTableHeaders = {
  "Related Products": connectionHeaders,
  Availability: connectionHeaders,
  Price: connectionHeaders,
  Products: connectionHeaders,
  Orders: connectionHeaders,
  Schedule: scheduleTableHeaders,
  Substitutes: connectionHeaders,
};

export const connectionTableApi = {
  Availability: "logs/availability",
  Products: "logs/products",
  Orders: "logs/orders",
  Price: "logs/prices",
  Schedule: "schedule",
  Substitutes: "logs/substitutes",
  "Related Products": "logs/relatedproducts",
  Accessories: "logs/accessories"
};

export const Constants = {
  Tabs: ["Related Products", "Availability", "Orders", "Price", "Products", "Substitutes", "Schedule"],
};

export const CHANNEL_ERROR = "Channel key is missing";
